/**
 * Type predicate to assert an argument is not undefined.
 */
export function notUndefined(x) {
  return x !== undefined;
}